// ===========================================
// "Amended" note on a family's invoice (2026-09-26)
// ===========================================
// Shown on the parent invoice card and details dialog when the school amended
// the invoice after sending it: an "Amended" chip and "Updated dd/mm/yyyy:
// <the school's reason>". The reason renders as React text (escaped). The
// admin's name and the before/after figures are never sent to a parent.

import { Box, Chip, Typography } from '@mui/material';
import type { InvoiceLatestAmendment } from '../../api/invoices.api';
import { formatInSchoolTz } from '../../utils/dateUtils';

interface InvoiceAmendedNoteProps {
  latestAmendment: InvoiceLatestAmendment | null | undefined;
  timeZone: string;
}

export default function InvoiceAmendedNote({ latestAmendment, timeZone }: InvoiceAmendedNoteProps) {
  if (!latestAmendment) return null;
  const day = formatInSchoolTz(latestAmendment.amendedAt, timeZone, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 0.5, flexWrap: 'wrap' }}>
      <Chip size="small" color="info" label="Amended" />
      <Typography variant="body2" color="text.secondary">
        Updated {day}: {latestAmendment.reason}
      </Typography>
    </Box>
  );
}
